import { gql } from "@apollo/client"

export const UPLOAD_AUDIO = gql`
    mutation uploadAudio($input: UploadAudioInput) {
        uploadAudio(uploadAudioInput: $input) {
            fileName
        }
    }
`
